/**
* Abstract Data Model class that serves as a basis for other
* data models and provides common functionality
*
* @class AbstractDataModel
*/
var AbstractDataModel = function ( data ) {
	var self = this;					// Convenience reference so the context
										// of 'this' becomes clearer

	self.data					= null;	// The XML data this model represents
	self.json					= null;	// JSON converted from the XML data

	// Return self (AbstractDataModel) to be chainable, for best practice
	return self;
};


/**
* Method to take XML data, store it in the data member, and provide
* a conversion from XML to JSON.
*
* @method loadData
* @param {XMLString} xmlData XML String representing this model's data
* @return {AbstractDataModel} Returns the data model as chainable, for best practice
*/
AbstractDataModel.prototype.loadData = function ( xmlData ) {
	this.data = xmlData;

	if ( xmlData != null ) {
		this.json = $.xml2json( xmlData );
	}

	// Return self (AbstractDataModel) to be chainable, for best practice
	return self;
};


/**
* Helper function to add ability to pad zeros in front of an integer
*
* @method pad
* @param {Integer} iNumber number to pad with zeros
* @param {Integer} iLength total length of string after padding
* @return {String} the passed in string, padded with zeros to the iLength
*/
AbstractDataModel.prototype.pad = function ( iNumber, iLength ) {
	// Ensure that the number passed is a number
	iNumber = parseInt( iNumber, 0 );

	// Get or default the length
	iLength = parseInt( iLength ) || 2;

	// Only other to proceed with padding if the number was an Integer
	if ( !isNaN( iNumber ) ) {

		// To get the length, convert the Integer into a String
		iNumber = '' + iNumber;

		// Iterate over the string until the length matches iLength
		while ( iNumber.length < iLength ) {
			iNumber = '0' + iNumber;
		}
	}

	return iNumber;
};


/**
* Method to take string 'true'/'false' and convert to native boolean value.
*
* @method parseBoolean
* @param {String} sBool XML String representing this model's data
* @return {Boolean} Returns true/false value or null
*/
AbstractDataModel.prototype.parseBoolean = function ( sBool ) {
	// If the string 'true' was passed, return true
	if (sBool && sBool.toLowerCase() == 'true') {
		return true;
	}
	// If the string 'false' was passed, return false
	else if (sBool && sBool.toLowerCase() == 'false') {
		return false;
	}
	// could not evaluate to true or false, return null
	else {
		return null;
	}
};

if (typeof exports !== 'undefined') {
  exports.AbstractDataModel = AbstractDataModel;
}

